<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>医疗科普</a></li>
            </ul>
            <div class="page-main">
                <h3>医疗科普</h3>
                <ul class="medical-ul">
                    <li class="medical-item" v-for="medical in medicalList" :key="medical.Id" @click="goDetail(medical)">
                        <h3 class="ellipsis_one">{{ medical.Title }}</h3>
                        <p class="ellipsis_six">{{ medical.SubTitle }}</p>
                    </li>
                    <!-- <li class="medical-item">
                        <h3>燕麦麸皮：比燕麦片方便还营养</h3>
                        <p class="ellipsis_six">燕麦麸皮不是100%的麸皮，剥离麸皮时会蹭下不少胚乳。根据澳新食品局的数据每百克燕麦麸皮的淀粉含量高达55.8克。这么看燕麦麸皮就是个主食担当。 每百克燕麦麸皮的蛋白含量为17.3克，是燕麦片的1.3倍，蛋白可以延长胃排空，增加饱腹感。从这点看，它也是比燕麦片更优秀的主食。</p>
                    </li>
                    <li class="medical-item">
                        <h3>燕麦麸皮：比燕麦片方便还营养</h3>
                        <p class="ellipsis_six">燕麦麸皮不是100%的麸皮，剥离麸皮时会蹭下不少胚乳。根据澳新食品局的数据每百克燕麦麸皮的淀粉含量高达55.8克。这么看燕麦麸皮就是个主食担当。 每百克燕麦麸皮的蛋白含量为17.3克，是燕麦片的1.3倍，蛋白可以延长胃排空，增加饱腹感。从这点看，它也是比燕麦片更优秀的主食。</p>
                    </li> -->
                </ul>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getMedicalKnowledge
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 12,
            medicalList: [],
        }
    },
    created() {
       this.getMedicalKnowledge();
    },
    methods: {
        getMedicalKnowledge() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
            };
            getMedicalKnowledge(params).then(res => {
                if (res.Code == 1) {
                    this.medicalList = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("医疗科普请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getMedicalKnowledge();
        },
        goDetail(medical) {
            let newUrl = this.$router.resolve({
                path:'/layout/medical-science-detail',
                query: {
                    id: medical.Id,
                    page: this.currentPage
                }
            });
            window.open(newUrl.href, '_blank');
        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.medical-ul{
    padding: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.medical-ul .medical-item:nth-child(3n) {
    margin-right:0;
}
.medical-item {
    width: 384px;
    height: 274px;
    padding: 0 22px;
    box-sizing: border-box;
    border: 1px solid #E5E5E5;
    /* background: url('../../assets/image/medical./png') no-repeat; */
    margin-right: 12px;
    cursor: pointer;
    margin-bottom: 12px;
    overflow: hidden;
}
.medical-item h3{
    height: 74px;
    color: #262626;
    font-size: 18px;
    line-height: 74px;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
    text-align: left;
}
.medical-item p {
    line-height: 26px;
    color: #6A6A6A;

}
</style>